import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {useNavigate} from "react-router-dom";
import {getVenueSession} from "../../requests/AppSession";
import {XMarkIcon} from "@heroicons/react/24/outline";
import {QuestionMarkCircleIcon, UsersIcon, XCircleIcon} from "@heroicons/react/20/solid";
import CircularProgress from "@mui/material/CircularProgress";
import {
    addDancerToVenueById,
    deleteDancerFromVenueById,
    getVenueDancerEdit,
    updateVenueDancerById
} from "../requests/AppRequestVenueEditDancer";
import {useAuth0} from "@auth0/auth0-react";
import {DancerListSkeleton} from "./VTSkeletons";

export default function VTAdminDancerEdit() {
    const {isLoading, getAccessTokenSilently} = useAuth0();

    let navigate = useNavigate();

    const [venueId, setVenueId] = React.useState(null);
    const [dancers, setDancers] = React.useState(null);
    const [dancersFiltered, setDancersFiltered] = React.useState(null);

    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const [errorMessage, setErrorMessage] = React.useState(null);

    const [openDancersField, setOpenDancersField] = useState(false);
    const [updateFieldEditMode, setUpdateFieldEditMode] = useState(null);
    const [updateFieldValue, setUpdateFieldValue] = useState(null);
    const [updateFieldName, setUpdateFieldName] = useState(null);
    const [updateFieldDisplayName, setUpdateFieldDisplayName] = useState(null);
    const [updateFieldDescription, setUpdateFieldDescription] = useState(null);

    const [dancerAppManagementFeatureFlag, setDancerAppManagementFeatureFlag] = React.useState(false);


    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.venueId && venueSession.venueId !== null) {
                setVenueId(venueSession.venueId);
                setDancerAppManagementFeatureFlag(venueSession.dancerAppManagementFeatureFlag);
            } else {
                navigate('/login/mobile', {replace: true});
            }
        })
        return function cleanup() {

        };
    }, []);

    useEffect(() => {
        if (dancerAppManagementFeatureFlag) {
            navigate('/login/mobile', {replace: true});
        }
        return function cleanup() {

        };
    }, [dancerAppManagementFeatureFlag]);

    const getSuccess = async responseJson => {
        if (
            responseJson &&
            responseJson.id
        ) {
            setDancers(responseJson.dancers);
            setDancersFiltered(responseJson.dancers);
        } else {
            setErrorMessage("Error getting Venue Dancers, please refresh and verify Internet Connection.");
        }
    };

    const getError = forceLogout => {
        setErrorMessage("Error getting Venue Dancers, please refresh and verify Internet Connection.");
    };

    const updateSuccess = async responseJson => {
        setIsSubmitting(false);

        if (
            responseJson &&
            responseJson.id
        ) {
            setDancers(responseJson.dancers);
            setDancersFiltered(responseJson.dancers);
            setOpenDancersField(false);
        } else {
            setErrorMessage(responseJson.message);
        }
    };

    const updateError = forceLogout => {
        setIsSubmitting(false);
        //setOpenDancersField(false);
        setErrorMessage("Error getting Venue updating dancer, please refresh and verify Internet Connection.");
    };

    useEffect(() => {
        if (!isLoading && venueId !== null) {
            getVenueDancerEdit(venueId, getSuccess, getError, getAccessTokenSilently);
        }
        return function cleanup() {

        };
    }, [isLoading, venueId]);

    const updateDancersField = (fieldValue, fieldName, displayName, description, editMode) => {
        setErrorMessage(null);
        setUpdateFieldEditMode(editMode);
        setUpdateFieldValue(fieldValue);
        setUpdateFieldName(fieldName);
        setUpdateFieldDisplayName(displayName);
        setUpdateFieldDescription(description);
        setOpenDancersField(true);
    };

    const clearUpdateField = () => {
        setErrorMessage(null);
        setUpdateFieldEditMode(null);
        setUpdateFieldValue(null);
        setUpdateFieldName(null);
        setUpdateFieldDisplayName(null);
        setUpdateFieldDescription(null);
    };

    return (
        <>
            <div className="mx-auto max-w-7xl lg:flex lg:gap-x-16 lg:px-8">
                <main className="px-4 py-2 sm:px-6 lg:flex-auto lg:px-0 lg:py-20">
                    <div className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none">
                        <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900 dark:text-gray-100">Dancers {dancersFiltered && "(" + dancersFiltered.length + ")"}</h2>
                            <p className="mt-1 text-sm leading-6 text-gray-500 dark:text-gray-400">Dancers that dance at your venue.</p>


                            <div className="relative mt-2 rounded-md shadow-sm">
                                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                    <UsersIcon className="h-5 w-5 text-gray-400 dark:text-gray-500" aria-hidden="true"/>
                                </div>
                                <input
                                    type="text"
                                    name="search"
                                    className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 dark:text-gray-100 dark:bg-gray-800 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                    placeholder="Search"
                                    onChange={(event) => {
                                        if (event.target.value && event.target.value.length > 0) {
                                            let filteredDancers = dancers.filter(function (dancer) {
                                                return dancer.name.substring(0, event.target.value.length).toLowerCase() === event.target.value.toLowerCase();
                                            });
                                            setDancersFiltered(filteredDancers);
                                        } else {
                                            setDancersFiltered(dancers);
                                        }
                                    }}
                                />
                            </div>

                            {!dancers && <DancerListSkeleton/>}

                            {dancers && <div className="flex border-t border-gray-100 dark:border-gray-700 pt-6">
                                <button type="button"
                                        className="text-sm font-semibold leading-6 text-pink-600 hover:text-pink-500"
                                        onClick={() => {
                                            updateDancersField({}, "dancerSelectionDto", "Dancer", "Update the dancer.", false);
                                        }}
                                >
                                    <span aria-hidden="true">+</span> Add dancer
                                </button>
                            </div>}

                            <ul role="list"
                                className="mt-6 divide-y divide-gray-100 dark:divide-gray-700 border-t border-gray-200 dark:border-gray-700 text-sm leading-6">
                                {dancersFiltered && dancersFiltered.map((dancer) => (
                                    <li key={dancer.id} className="flex justify-between gap-x-6 py-6">
                                        <div
                                            className="font-medium text-gray-900 dark:text-gray-100">{dancer.name} - {dancer.dancerCode}</div>
                                        <button
                                            type="button"
                                            className="font-semibold text-pink-600 hover:text-pink-500"
                                            onClick={() => {
                                                updateDancersField(dancer, "dancerSelectionDto", "Dancer", "Update the dancer.", true);
                                            }}
                                        >
                                            Update
                                        </button>
                                    </li>
                                ))}
                            </ul>

                            {dancers && <div className="flex border-t border-gray-100 dark:border-gray-700 pt-6">
                                <button type="button"
                                        className="text-sm font-semibold leading-6 text-pink-600 hover:text-pink-500"
                                        onClick={() => {
                                            updateDancersField({}, "dancerSelectionDto", "Dancer", "Update the dancer.", false);
                                        }}
                                >
                                    <span aria-hidden="true">+</span> Add dancer
                                </button>
                            </div>}
                        </div>
                    </div>
                </main>
            </div>

            {/*EDIT Dancer FIELD*/}
            <Transition.Root show={openDancersField} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenDancersField}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 shadow-xl">
                                            <div className="h-0 flex-1 overflow-y-auto">
                                                <div className="bg-pink-700 px-4 py-6 sm:px-6">
                                                    <div className="flex items-center justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-white">
                                                            Update {updateFieldDisplayName}
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="rounded-md bg-pink-700 text-pink-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                                onClick={() => {
                                                                    clearUpdateField();
                                                                    setOpenDancersField(false);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="mt-1">
                                                        <p className="text-sm text-pink-300">
                                                            {updateFieldDescription}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex flex-1 flex-col justify-between">
                                                    <div className="divide-y divide-gray-200 dark:divide-gray-700 px-4 sm:px-6">
                                                        <div className="space-y-6 pb-5 pt-6">
                                                            <div>
                                                                <label
                                                                    htmlFor="project-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    Name
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        type="text"
                                                                        name="updateFieldName"
                                                                        value={updateFieldValue ? updateFieldValue.name : ""}
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                        onChange={(event) => {
                                                                            const fieldJson = {...updateFieldValue};
                                                                            fieldJson.name = event.target.value;
                                                                            setUpdateFieldValue(fieldJson);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {updateFieldEditMode && <div className="pb-6 pt-4">
                                                            <div className="flex text-sm">
                                                                <button
                                                                    disabled={isSubmitting}
                                                                    className="group inline-flex items-center font-medium text-pink-600 hover:text-pink-900"
                                                                    onClick={() => {
                                                                        setIsSubmitting(true);
                                                                        setErrorMessage(null);
                                                                        const fieldName = "dancerSelectionDto";
                                                                        const params = {};
                                                                        params[fieldName] = updateFieldValue;
                                                                        deleteDancerFromVenueById(venueId, params, updateSuccess, updateError, getAccessTokenSilently);
                                                                    }}
                                                                >
                                                                    <XMarkIcon
                                                                        className="h-5 w-5 text-pink-500 group-hover:text-pink-900"
                                                                        aria-hidden="true"
                                                                    />
                                                                    <span className="ml-2">Delete Dancer</span>
                                                                </button>
                                                            </div>
                                                            <div className="mt-4 flex text-sm">
                                                                <a href="#"
                                                                   className="group inline-flex items-center text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                                                                    <QuestionMarkCircleIcon
                                                                        className="h-5 w-5 text-gray-400 dark:text-gray-500 group-hover:text-gray-500"
                                                                        aria-hidden="true"
                                                                    />
                                                                    <span
                                                                        className="ml-2">If dancer is on stage or has not been completely paid out then the dancer cannot be updated or deleted.</span>
                                                                </a>
                                                            </div>
                                                        </div>}
                                                    </div>

                                                    {errorMessage && <div className="rounded-md bg-red-50 p-10 mb-2">
                                                        <div className="flex">
                                                            <div className="flex-shrink-0">
                                                                <XCircleIcon className="h-5 w-5 text-red-400"
                                                                             aria-hidden="true"/>
                                                            </div>
                                                            <div className="ml-3">
                                                                <h3 className="text-sm font-medium text-red-800">{errorMessage}</h3>
                                                            </div>
                                                        </div>
                                                    </div>}

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white dark:bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                    onClick={() => {
                                                        setErrorMessage(null);
                                                        setOpenDancersField(false);
                                                        clearUpdateField();
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    disabled={isSubmitting}
                                                    type="button"
                                                    className="ml-4 inline-flex justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                                    onClick={() => {
                                                        setErrorMessage(null);
                                                        setIsSubmitting(true);
                                                        const fieldName = "dancerSelectionDto";
                                                        const params = {};
                                                        params[fieldName] = updateFieldValue;
                                                        if (updateFieldEditMode) {
                                                            updateVenueDancerById(venueId, params, updateSuccess, updateError, getAccessTokenSilently);
                                                        } else {
                                                            addDancerToVenueById(venueId, params, updateSuccess, updateError, getAccessTokenSilently);
                                                        }
                                                    }}
                                                >
                                                    Save {isSubmitting &&
                                                    <CircularProgress color="inherit" size={20}/>}
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

        </>
    )
}
